import {
  Actions,
  GetUsernameRequest,
  GetUsernameResponse,
  PutUsernameRequest,
  PutUsernameResponse,
} from "@craftdig-io/common";

export const api = {
  async getUsername(req: GetUsernameRequest): Promise<GetUsernameResponse> {
    return this.post(req, "GetUsername");
  },

  async putUsername(req: PutUsernameRequest): Promise<PutUsernameResponse> {
    return this.post(req, "PutUsername");
  },

  async post<T>(req: object, action: string): Promise<T> {
    const jwt = localStorage.getItem("jwt");

    const response = await fetch(`/api/${action}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify(Actions[action].Request.parse(req)),
    });

    if (!response.ok) {
      throw new Error(`Failed ${action}: ${response.statusText}`);
    }

    return Actions[action].Response.parse(await response.json()) as T;
  },
};
